/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {ChangeDetectorRef, Component, EventEmitter, Input, Optional, Output} from '@angular/core';

// providers

import {AlertIconAndTypesService} from './providers/icon-and-types-service';
import {MultiAlertService} from './providers/multi-alert-service';
export class Alert {
/**
 * @param {?} iconService
 * @param {?} cdr
 * @param {?} multiAlertService
 */
constructor(public iconService: AlertIconAndTypesService,
public cdr: ChangeDetectorRef,
public multiAlertService: MultiAlertService) {}

     isSmall: boolean = false;
     closable: boolean = true;
     isAppLevel: boolean = false;

     _closed: boolean = false;
     _closedChanged: EventEmitter<boolean> = new EventEmitter<boolean>(false);
/**
 * @param {?} val
 * @return {?}
 */
set alertType(val: string) {
        this.iconService.alertType = val;
    }
/**
 * @return {?}
 */
get alertType(): string {
        return this.iconService.alertType;
    }
/**
 * @param {?} value
 * @return {?}
 */
set alertIconShape(value: string) {
        this.iconService.alertIconShape = value;
    }
/**
 * @return {?}
 */
get alertClass(): string {
        return this.iconService.iconInfoFromType(this.iconService.alertType).cssClass;
    }
private previouslyHidden = false;
private hidden = false;
/**
 * @return {?}
 */
private detectChangesIfNeeded() {
        if (this.previouslyHidden !== this.hidden) {
            this.previouslyHidden = this.hidden;
            this.cdr.detectChanges();
        }
    }
/**
 * @return {?}
 */
get isHidden() {
        if (this.multiAlertService) {
            if (this.multiAlertService.currentAlert === this) {
                if (this.hidden === true) {
                    this.previouslyHidden = true;
                    this.hidden = false;
                }
            } else if (this.hidden === false) {
                this.previouslyHidden = false;
                this.hidden = true;
            }
            this.detectChangesIfNeeded();
        }

        return this.hidden;
    }
/**
 * @return {?}
 */
close(): void {
        if (!this.closable) {
            return;
        }
        this._closed = true;
        if (this.multiAlertService) {
            this.multiAlertService.close();
        }
        this._closedChanged.emit(true);
    }
/**
 * @return {?}
 */
open(): void {
        this._closed = false;
        this._closedChanged.emit(false);
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{selector: "clr-alert", providers: [AlertIconAndTypesService], template: `
  <!--
    ~ Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
    ~ This software is released under MIT license.
    ~ The full license information can be found in LICENSE in the root directory of this project.
    -->

  <div
      *ngIf="!_closed"
      class="alert"
      [ngClass]="alertClass"
      [class.alert-hidden]="isHidden"
      [class.alert-sm]="isSmall"
      [class.alert-app-level]="isAppLevel">
      <div class="alert-items">
          <ng-content></ng-content>
      </div>
      <button type="button" class="close" aria-label="Close" *ngIf="closable" (click)="close()">
          <clr-icon aria-hidden="true" shape="close"></clr-icon>
      </button>
  </div>
`}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: AlertIconAndTypesService, },
{type: ChangeDetectorRef, },
{type: MultiAlertService, decorators: [{ type: Optional }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'isSmall': [{ type: Input, args: ["clrAlertSizeSmall", ] },],
'closable': [{ type: Input, args: ["clrAlertClosable", ] },],
'isAppLevel': [{ type: Input, args: ["clrAlertAppLevel", ] },],
'_closed': [{ type: Input, args: ["clrAlertClosed", ] },],
'_closedChanged': [{ type: Output, args: ["clrAlertClosedChange", ] },],
'alertType': [{ type: Input, args: ["clrAlertType", ] },],
'alertIconShape': [{ type: Input, args: ["clrAlertIcon", ] },],
};
}

function Alert_tsickle_Closure_declarations() {
/** @type {?} */
Alert.decorators;
/**
 * @nocollapse
 * @type {?}
 */
Alert.ctorParameters;
/** @type {?} */
Alert.propDecorators;
/** @type {?} */
Alert.prototype.isSmall;
/** @type {?} */
Alert.prototype.closable;
/** @type {?} */
Alert.prototype.isAppLevel;
/** @type {?} */
Alert.prototype._closed;
/** @type {?} */
Alert.prototype._closedChanged;
/** @type {?} */
Alert.prototype.previouslyHidden;
/** @type {?} */
Alert.prototype.hidden;
/** @type {?} */
Alert.prototype.iconService;
/** @type {?} */
Alert.prototype.cdr;
/** @type {?} */
Alert.prototype.multiAlertService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
